import Repository from "../Repository";

const resource = "/bo/parameter/brackets";
export default {
  // Gets brackets settings
  async get() {
    const { data } = await Repository.get(`${resource}`);
    return data;
  }
};
